import React from "react";
import { EMPLOYERS } from "../data/mock";
import Reveal from "../components/Reveal";
import { PageHero, SectionHead, NumberedRow, CTABand } from "../components/SharedUI";

const Employers = () => {
  const d = EMPLOYERS;
  return (
    <div>
      <PageHero eyebrow={d.eyebrow} lines={d.titleLines} intro={d.intro} cta={d.cta} />

      {/* Reasons */}
      <section className="bg-[var(--cream)] py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-32 self-start">
            <SectionHead eyebrow={d.reasons.eyebrow} title={d.reasons.title} />
          </div>
          <div>
            {d.reasons.items.map((it, i) => (
              <NumberedRow key={it.num} {...it} delay={i * 80} />
            ))}
            <div className="border-t border-black/10" />
          </div>
        </div>
      </section>

      {/* Engagements */}
      <section className="grain bg-[#16233f] text-white py-24 md:py-32">
        <div className="max-w-[1280px] mx-auto px-6 md:px-8">
          <Reveal>
            <div className="eyebrow mb-4">{d.engagements.eyebrow}</div>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="font-serif text-[38px] md:text-[52px] font-semibold mb-16 max-w-2xl">{d.engagements.title}</h2>
          </Reveal>
          <div className="grid md:grid-cols-3 gap-8">
            {d.engagements.items.map((it, i) => (
              <Reveal key={it.num} delay={i * 100}>
                <div className="border border-white/10 rounded-sm p-8 h-full hover:border-[var(--gold)]/40 hover:-translate-y-1 transition-all duration-300">
                  <div className="font-serif text-4xl text-[var(--gold)]/70 mb-5">{it.num}</div>
                  <h3 className="font-serif text-2xl font-semibold mb-3">{it.title}</h3>
                  <p className="text-white/60 text-sm leading-relaxed">{it.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CTABand title={d.cta2.title} button={d.cta2.button} />
    </div>
  );
};

export default Employers;
